// Modules
import {AnyAction, combineReducers, configureStore} from "@reduxjs/toolkit";
import {createWrapper, HYDRATE} from "next-redux-wrapper";

// Reducers
import searchBarReducer from "redux/searchBar/searchBarSlice";
import categoriesReducer from "redux/categories/categoriesSlice";
import seoInformationsReducer from "redux/seoInformations/seoInformationsSlice";
import filtersReducer from "redux/filters/filtersSlice";
import paginationReducer from "redux/pagination/paginationSlice";
import showResultsReducer from "redux/showResults/showResultsSlice";


// Map reducer how this will be stored
const rootReducer = combineReducers({
	searchBar: searchBarReducer,
	categories: categoriesReducer,
	seoInformations: seoInformationsReducer,
	filters: filtersReducer,
	showResults: showResultsReducer,
	pagination: paginationReducer,
});

const reducer = (state: ReturnType<typeof rootReducer> | undefined, action: AnyAction) => {
	if (action.type === HYDRATE) {
		return {
			...state, // use previous state
			...action.payload, // apply delta from hydration
		};
	} else {
		return rootReducer(state, action);
	}
};

export const makeStore = () =>
	configureStore({
		reducer,
	});

const wrapper = createWrapper<Store>(makeStore);

type Store = ReturnType<typeof makeStore>;

export type AppState = ReturnType<Store["getState"]>;
export type AppDispatch = Store["dispatch"];

export default wrapper;